// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__AvVqhNj9DWqBfDGjq0qH {
  display: inline;
  line-height: 0;
}
@media (forced-colors: active) {
  .root__AvVqhNj9DWqBfDGjq0qH {
    forced-color-adjust: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/icons/createSvgIcon.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".root {\n  display: inline;\n  line-height: 0;\n}\n@media (forced-colors: active) {\n  .root {\n    forced-color-adjust: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__AvVqhNj9DWqBfDGjq0qH`
};
export default ___CSS_LOADER_EXPORT___;
